var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInconclusive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M1986.889,7759.741c.276-1.236-.722-2.215,0-3.35s2.789-.93,3.2-1.652.336-3.868,3.63-4.189,5.595,3.5,6.438,3.555,5.583-.35,7.191,2.286-1.3,4.964-1.449,6.583,2.407,3.7,1.449,5.305-3.423.282-4.06.973-.394,4.989-3.8,5.258-4.358-2.3-5.312-2.633-3.12.888-4.964,0-.116-3.595-.636-4.143-4.569-1.578-4.732-4.121S1986.889,7759.741,1986.889,7759.741Z",
    transform: "translate(-1983.826 -7750.53)",
    fill: "#1b4480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInconclusive);
export default __webpack_public_path__ + "static/media/inconclusive.7ccec652cbefe69bd8547d78b7910edb.svg";
export { ForwardRef as ReactComponent };